import React, { useState, useEffect } from 'react';
import './RatingInputStar.css';

const RatingInputStar = ({ value, edit, onChange, maxRating = 5.0, step = 0.5, displayPrecision=1 }) => {   
    const [rawScore, setRawScore] = useState(String(parseFloat(value).toFixed(displayPrecision)));
    const [displayScore, setDisplayScore] = useState(parseFloat(value).toFixed(displayPrecision));

    useEffect(() => {
        if (value === null || value === undefined) {
            setRawScore('');
            setDisplayScore('');
        } else {
            const n = parseFloat(value);
            const text = Number.isFinite(n) ? n.toFixed(displayPrecision) : '';
            setRawScore(text);
            setDisplayScore(text);
        }

    }, [value]);

    const applyScoreLogic = (newValue) => {
        if (!Number.isFinite(newValue)) return null;
        const clamped = Math.max(0, Math.min(maxRating, newValue));
        return Math.round(clamped / step) * step;
    };

    const handleInputBlur = () => {
        if (!edit) return;

        let parsedValue = parseFloat(rawScore);
        const finalScore = applyScoreLogic(parsedValue);

        if (finalScore === null) {
            setDisplayScore('');
            setRawScore('');
            onChange && onChange(null);
            return;
        }

        const txt = finalScore.toFixed(1);
        setDisplayScore(txt);
        setRawScore(txt);
        onChange && onChange(finalScore);
    };

    const updateScore = (delta) => {
        if (!edit) return;

        let current = parseFloat(displayScore);
        if (!Number.isFinite(current)) current = 0;

        let newScoreValue;
        if (delta > 0) {
            newScoreValue = Math.min(maxRating, current + delta);
        } else {
            newScoreValue = Math.max(0.0, current + delta);
        }

        newScoreValue = applyScoreLogic(newScoreValue);

        const txt = newScoreValue?.toFixed(1);
        setDisplayScore(txt);
        setRawScore(txt);
        onChange && onChange(newScoreValue);
    };


    const handleRawScoreChange = (event) => {
        if (!edit) return;
        setRawScore(event.target.value);
    };

    const incrementScore = () => {
        updateScore(step);
    };

    const decrementScore = () => {
        updateScore(-step);
    };

    return (
        <div className="rating-input-star-container">
            <div className="star-icon">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="#B82222"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279L12 18.896l-7.416 3.817 1.48-8.279L.004 9.306l8.332-1.151L12 .587z" />
                </svg>
            </div>
            {!edit ? (
                <div className="readonly-score">{displayScore}</div>
            ) : (
                <div className="score-input-wrapper">
                    <input
                        type="number"
                        value={rawScore}
                        onChange={handleRawScoreChange}
                        onBlur={handleInputBlur}
                        min="0"
                        max={maxRating}
                        step={step}
                        readOnly={!edit}
                        className="score-input"
                    />
                    <div className="score-controls-right">
                        <button onClick={incrementScore} className="score-control-btn increment">▲</button>
                        <button onClick={decrementScore} className="score-control-btn decrement">▼</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RatingInputStar;